import MethodsList from './MethodsList';

export default MethodsList;